import { useEffect, useState } from "react";
import { Main, ContenedorTitulo, ContenedorDatos } from "../Historico/ElementosStyles"
import { Button, Table } from "react-bootstrap";
import Tooltip from "react-tooltip";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalCentro from "../../components/Modal/Modal Centro"
import Api from "../../services/api-service";
import { useHistory } from "react-router-dom";
import { contains } from "rsuite/esm/DOMHelper";
import Swal from "sweetalert2";

const Organizaciones = () => {
    const history = useHistory();
    const [organizaciones, setOrganizaciones] = useState([]);
    const [organizacion, setOrganizacion] = useState([]);
    const [organizationPage, setOrganizationPage] = useState(1);
    const [showModalView, setShowModalView] = useState(false)
    const [fact, setFact] = useState({})
    const itemsPerPage = 10;
    const totalOrganization = organizaciones.length;
    const totalPagesOrg = Math.ceil(totalOrganization / itemsPerPage);

    useEffect(() => {
        Api.getListEmpresas()
            .then((res) => {
                console.log(res)
                setOrganizaciones(res);
            })
            .catch((error) => console.log(error));

    }, [])

    const currentOrg = organizaciones.slice(
        (organizationPage - 1) * itemsPerPage,
        organizationPage * itemsPerPage
    );

    const paginateDevices = (pageNumber) => setOrganizationPage(pageNumber);

    const handleNextDevices = () => {
        if (organizationPage < totalPagesOrg)
            paginateDevices(organizationPage + 1);
    };

    const handlePreviousDevices = () => {
        if (organizationPage > 1) paginateDevices(organizationPage - 1);
    };

    const renderPaginationButtons = (
        currentPage,
        totalPages,
        paginate,
        handleNext,
        handlePrevious
    ) => {
        const buttons = [];
        const startPage = Math.max(1, currentPage - 1);
        const endPage = Math.min(totalPages, currentPage + 1);

        if (startPage > 1) {
            buttons.push(
                <Button
                    key={1}
                    onClick={() => paginate(1)}
                    size="sm"
                    style={{
                        margin: "0 3px",
                        backgroundColor: "#fff",
                        color: "#007bff",
                    }}
                >
                    1
                </Button>
            );
            if (startPage > 2) buttons.push(<span key="dots1">...</span>);
        }

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <Button
                    key={i}
                    onClick={() => paginate(i)}
                    size="sm"
                    style={{
                        margin: "0 3px",
                        backgroundColor: currentPage === i ? "#007bff" : "#fff",
                        color: currentPage === i ? "#fff" : "#007bff",
                    }}
                >
                    {i}
                </Button>
            );
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) buttons.push(<span key="dots2">...</span>);
            buttons.push(
                <Button
                    key={totalPages}
                    onClick={() => paginate(totalPages)}
                    size="sm"
                    style={{
                        margin: "0 3px",
                        backgroundColor: "#fff",
                        color: "#007bff",
                    }}
                >
                    {totalPages}
                </Button>
            );
        }

        return (
            <div>
                <Button
                    onClick={handlePrevious}
                    disabled={currentPage === 1}
                    size="sm"
                    style={{
                        margin: "0 5px",
                        backgroundColor: "#fff",
                        color: "#007bff",
                    }}
                >
                    &lt;
                </Button>
                {buttons}
                <Button
                    onClick={handleNext}
                    disabled={currentPage === totalPages}
                    size="sm"
                    style={{
                        margin: "0 5px",
                        backgroundColor: "#fff",
                        color: "#007bff",
                    }}
                >
                    &gt;
                </Button>
            </div>
        );
    };

    const mostrarOrganizacion = async (org) => {
        console.log(org)
        await Api.getFacturacion(org._id)
            .then((res) => {
                if (res) {
                    setFact(res);
                }
            })
            .catch((error) => console.log(error));
        setOrganizacion(org)
        setShowModalView(true)
    }

    const actualizarFact = async (fact) => {
        console.log("entre a actualizar", fact)
        if ("organizacion" in fact) {
            console.log("si tiene _id")
        } else {
            fact.organizacion = organizacion._id
        }
        await Api.setFacturacion(fact.organizacion, fact.tipo)
            .then((res) => {
                Swal.fire({
                    title: "Actualizar facturación",
                    text: res.mensaje,
                    icon: "success",
                    confirmButtonText: "OK"
                });
                setShowModalView(false)
                setFact({})
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    title: "Error",
                    text: error.response?.data?.message || "Ocurrió un error",
                    icon: "error",
                    confirmButtonText: "OK"
                });
            });
    }
    return (
        <>
            <Main>
                <ContenedorTitulo>Organizaciones</ContenedorTitulo>
                <ContenedorDatos>
                    <Table responsive>
                        <thead>
                            <tr class="table-active">
                                <th>Nombre</th>
                                <th>Organizacion</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentOrg.map((organization, index) => (
                                <tr key={index}>
                                    <td>{organization.nombre}</td>
                                    <td>{organization.organizacion}</td>
                                    <td>
                                        <Tooltip
                                            id="ver-tooltip"
                                            place="top"
                                            effect="solid"
                                        >
                                            Información
                                        </Tooltip>
                                        <VisibilityIcon
                                            data-tip
                                            data-for="ver-tooltip"
                                            onClick={() => mostrarOrganizacion(organization)}
                                            style={{ marginRight: '1rem', color: "#fdddca", cursor: "pointer" }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {renderPaginationButtons(
                        organizationPage,
                        totalPagesOrg,
                        paginateDevices,
                        handleNextDevices,
                        handlePreviousDevices
                    )}
                </ContenedorDatos>
            </Main>

            <div>
                <ModalCentro isOpen={showModalView}>
                    <Button style={{ position: "absolute", top: "10px", right: "10px" }} onClick={() => { setShowModalView(false); setFact({}) }}>
                        X
                    </Button>
                    <div>
                        <p><b>Organizacion:</b> {organizacion.nombre}</p>
                        <p><b>Tipo Facturación:</b> {""}
                            <select
                                value={fact.tipo ?? ""} // 👈 carga el valor actual
                                onChange={(e) => setFact({ ...fact, tipo: e.target.value })} // 👈 actualiza el estado
                            >
                                <option value="" disabled={true}>-- Selecciona --</option>
                                <option value="mensual">Mensual</option>
                                <option value="trimestral">Trimestral</option>
                                <option value="semestral">Semestral</option>
                            </select>
                        </p>

                        <p>
                            <b>Última facturación:</b>{" "}
                            {fact?.ultimaNoti
                                ? new Date(fact.ultimaNoti).toLocaleDateString("es-EC", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                })
                                : "No registrado"}
                        </p>

                        <p>
                            <b>Próxima facturación:</b>{" "}
                            {fact?.proxNoti
                                ? new Date(fact.proxNoti).toLocaleDateString("es-EC", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                })
                                : "No registrado"}
                        </p>
                        <button
                            onClick={() => actualizarFact(fact)}
                        >Actualizar
                        </button>
                    </div>
                </ModalCentro>
            </div>
        </>

    )
}

export default Organizaciones